































import type { Dsr, Page } from '@getaccept/dsr-shared';
import type { DocumentValues } from '@getaccept/editor-lib';
import { EditorBlockView } from '@getaccept/editor-view';
import type { EditorRecipientInput } from '@getaccept/lib-shared/src/types/editor-recipient-input';
import type { Entity } from '@getaccept/lib-shared/src/types/entity';
import type { Recipient } from '@getaccept/lib-shared/src/types/Recipient';
import type { ComputedRef, PropType } from '@vue/composition-api';
import { computed, defineComponent } from '@vue/composition-api';
import { storeToRefs } from 'pinia';
import { useSessionStore } from '../../../session/session.store';
import { useParticipantsStore } from '../../store/participants.store';
import { useTracking } from '../tracking/composables/tracking.composable';
import { pusherClient } from '../../../api/pusher/pusher-client';

export default defineComponent({
  name: 'EditorWrapper',
  components: {
    EditorBlockView,
  },
  props: {
    page: {
      required: true,
      type: Object as PropType<Page>,
    },
    entity: {
      default: () => ({}),
      type: Object as PropType<Entity>,
    },
    recipientInput: {
      default: () => [],
      type: Array as PropType<EditorRecipientInput[]>,
    },
    dsr: {
      required: true,
      type: Object as PropType<Dsr>,
    },
    authId: {
      required: true,
      type: String,
    },
    recipient: {
      default: () => ({}),
      type: Object as PropType<Recipient>,
    },
    token: {
      required: true,
      type: Object as PropType<{
        jwt: string;
        exp: number;
      }>,
    },
  },
  setup(props) {
    const participantsStore = useParticipantsStore();
    const { recipients, user } = storeToRefs(participantsStore);

    const sessionStore = useSessionStore();
    const { observeNodeVisibility, observeSectionVisibility, postClickTracking } = useTracking();

    const documentValues: ComputedRef<DocumentValues> = computed(() => {
      const { name, value, sendDate, uniqueId, expirationDate } = props.dsr || {};
      return { name, value, sendDate, uniqueId, expirationDate };
    });

    const mergeValues = computed(() => ({
      document: documentValues.value,
      sender: user.value,
      recipients: recipients.value,
      entity: props.entity,
    }));

    return {
      setToken: sessionStore.setToken,
      observeSectionVisibility,
      observeNodeVisibility,
      postClickTracking,
      mergeValues,
      user,
      pusherClient,
    };
  },
});
